import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '产品与服务', path: '/products' },
  { label: '解决方案', path: '/solutions' },
  { label: '成功案例', path: '/cases' },
  { label: '关于我们', path: '/about' },
  { label: '资讯中心', path: '/insights' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';
  const isTransparent = isHome && !scrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        isTransparent
          ? 'bg-white/70 backdrop-blur-sm border-b border-white/40'
          : 'bg-white/95 backdrop-blur-md border-b border-gray-100'
      }`}
      style={{ boxShadow: isTransparent ? 'none' : '0 1px 20px rgba(0,0,0,0.06)' }}
    >
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-[68px]">
          {/* Logo */}
          <Link to="/" className="shrink-0 flex items-center gap-2">
            <img
              src="/images/logo.png"
              alt="融慧数科"
              className={`h-7 md:h-8 w-auto object-contain transition-all duration-300 ${
                isTransparent ? '' : ''
              }`}
            />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-0.5">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative px-3.5 xl:px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 whitespace-nowrap group ${
                  location.pathname === link.path
                    ? 'text-[#1E5FAD]'
                    : 'text-[#333333] hover:text-[#1E5FAD]'
                }`}
              >
                {link.label}
                <span
                  className={`absolute bottom-0 left-1/2 -translate-x-1/2 h-0.5 bg-[#00AEEF] rounded-full transition-all duration-200 ${
                    location.pathname === link.path ? 'w-4' : 'w-0 group-hover:w-4'
                  }`}
                />
              </Link>
            ))}
          </div>

          {/* Right CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/contact"
              className="px-5 py-2 text-sm font-medium rounded-md border border-[#1E5FAD]/30 text-[#1E5FAD] hover:bg-[#1E5FAD]/5 transition-all duration-200 whitespace-nowrap"
            >
              联系我们
            </Link>
            <Link
              to="/contact"
              className="px-5 py-2 bg-[#00AEEF] text-white text-sm font-semibold rounded-md hover:bg-[#0099d4] transition-all duration-200 whitespace-nowrap"
            >
              预约演示
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden p-2 rounded-md transition-colors text-[#333333] hover:bg-gray-100"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-4 py-3 space-y-0.5">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                  location.pathname === link.path
                    ? 'text-[#1E5FAD] bg-[#1E5FAD]/5'
                    : 'text-[#333333] hover:text-[#1E5FAD] hover:bg-gray-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-2 pb-1 flex flex-col gap-2">
              <Link
                to="/contact"
                className="block px-4 py-2.5 border border-[#1E5FAD]/30 text-[#1E5FAD] text-sm font-medium rounded-lg text-center hover:bg-[#1E5FAD]/5 transition-colors"
              >
                联系我们
              </Link>
              <Link
                to="/contact"
                className="block px-4 py-2.5 bg-[#00AEEF] text-white text-sm font-semibold rounded-lg text-center hover:bg-[#0099d4] transition-colors"
              >
                预约演示
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
